import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export const inquiryEvents = {
  onUpdated: new SignalDispatcher(),
  onVariantUpdated: new SimpleEventDispatcher<number>(),
  onTierPricePatched: new SimpleEventDispatcher<{
    tierId: number;
    price: number | null;
  }>(),
};
